const state = {
  events: [],
  currentEventId: null,
  eventSummary: []
}

export default state
